export const COMMON_EXPENSE_ARRAY = [];


// WEBPACK FOOTER //
// ./src/app/contants/COMMON_EXPENSE_ARRAY.ts